import { FC } from 'react';

import { useMediaQuery } from '@/hooks/useMediaQuery';

import * as S from './CardSkeleton.styles';

type CardSkeletonProps = { isProfile?: boolean };

export const CardSkeleton: FC<CardSkeletonProps> = ({ isProfile }) => {
  const isMobile = useMediaQuery('mobile');

  const infoLineWidth = isMobile ? 80 : 100;
  return (
    <S.Wrapper data-testid="card-skeleton" $isMobile={isMobile}>
      <S.Header>
        <S.SkeletonLine width={33} />
      </S.Header>

      <S.Content $isBig={isProfile || isMobile}>
        <S.Info>
          <S.InfoLines>
            <S.SkeletonLine width={infoLineWidth} />
            <S.SkeletonLine width={infoLineWidth} height={16} />
          </S.InfoLines>

          <S.SkeletonCircle $size={isMobile ? 40 : 55} />
        </S.Info>

        {isProfile ? (
          <S.SkeletonLine width={33} />
        ) : (
          <S.Chips>
            <S.SkeletonLine height={34} />
            <S.SkeletonLine height={34} />
            <S.SkeletonLine height={34} />
          </S.Chips>
        )}

        <S.SkeletonLine height={5} />
        {isProfile && <S.SkeletonLine height={40} />}
      </S.Content>

      <S.Footer>
        <S.SkeletonLine height={16} width={36} />
        {!isMobile && isProfile && <S.SkeletonCircle $size={30} />}
      </S.Footer>
    </S.Wrapper>
  );
};
